module.exports = __webpack_public_path__ + "static/media/rebirth_1.ac968471.jpg";